export function getPrice(size, type) {
  if (size === "Mazas" && type === "Todzes") return 4.5;
  if (size === "Mazas" && type === "Paprastas") return 4.1;
  if (size === "Didelis" && type === "Todzes") return 5.1;
  if (size === "Didelis" && type === "Paprastas") return 4.7;
  return 0;
}
